import { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import PasswordInput from "./PasswordInput";
import "../users.css";

/* ── Inline SVG Icons (Lucide-style) ── */
const Icon = ({ d, size = 16, strokeWidth = 1.75, className = "" }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
    >
        {Array.isArray(d) ? d.map((path, i) => <path key={i} d={path} />) : <path d={d} />}
    </svg>
);

const icons = {
    users: ['M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2', 'M9 7a4 4 0 1 0 0-8 4 4 0 0 0 0 8z'],
    roles: ['M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z'],
    departments: ['M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z', 'M9 22V12h6v10'],
    search: ['M21 21l-6-6m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0z'],
    export: ['M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4', 'M7 10l5 5 5-5', 'M12 15V3'],
    plus: ['M12 5v14', 'M5 12h14'],
    trash: ['M3 6h18', 'M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6', 'M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2', 'M10 11v6', 'M14 11v6'],
    general: ['M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16z', 'M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z'],
    finance: ['M12 2v20', 'M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6'],
    fleet: ['M14 16H9m10 0h3v-3.15a1 1 0 0 0-.84-.99L16 11l-2.7-3.6a2 2 0 0 0-1.6-.8H6.5a2 2 0 0 0-2 2v7.5', 'M6 16a2 2 0 1 0 0 4 2 2 0 1 0 0-4zm12 0a2 2 0 1 0 0 4 2 2 0 1 0 0-4z'],
    maintenance: ['M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z'],
    vendors: ['M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2', 'M9 7a4 4 0 1 0 0-8 4 4 0 0 0 0 8z'],
    clients: ['M3 21h18', 'M9 8h1', 'M9 12h1', 'M9 16h1', 'M14 8h1', 'M14 12h1', 'M14 16h1', 'M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16'],
    subscriptions: ['M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8', 'M3 3v5h5', 'M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16', 'M16 21v-5h5'],
    countries: ['M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z', 'M2 12h20', 'M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z'],
    tickets: ['M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z', 'M13 5v2', 'M13 17v2', 'M13 11v2'],
    emailTemplates: ['M4 7.00005L10.2 11.65C11.2667 12.45 12.7333 12.45 13.8 11.65L20 7', 'M3 7l9 6 9-6', 'M21 16a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8z'],
    tripOps: ['M15 22a1 1 0 0 1-1-1v-4a1 1 0 0 1 .45-.83l3.04-2.12A3 3 0 0 0 19 11.6V5a3 3 0 0 0-3-3H8a3 3 0 0 0-3 3v6.6a3 3 0 0 0 1.51 2.45l3.04 2.12A1 1 0 0 1 10 17v4a1 1 0 0 1-1 1', 'M14 8h.01'],
    drivers: ['M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2', 'M9 7a4 4 0 1 0 0-8 4 4 0 0 0 0 8z'],
};

export default function Users({ user }) {
    const canManage = (perm) => {
        if (user?.userType === 'admin' && !user?.operatorId && (!user.role || user.role === 'System Admin' || user.role === 'Superadmin')) return true;
        if (user?.userType === 'operator' && user?._id === user?.operatorId) return true;
        return user?.permissions?.includes(perm);
    };

    const [activeTab, setActiveTab] = useState("users");
    const [showCreateRole, setShowCreateRole] = useState(false);
    const [showCreateDept, setShowCreateDept] = useState(false);
    const [showCreateUser, setShowCreateUser] = useState(false);
    const [showImportScreen, setShowImportScreen] = useState(false);

    // Editing states
    const [editingUser, setEditingUser] = useState(null);
    const [editingRole, setEditingRole] = useState(null);
    const [editingDept, setEditingDept] = useState(null);

    // Data states
    const [usersList, setUsersList] = useState([]);
    const [rolesList, setRolesList] = useState([]);
    const [deptsList, setDeptsList] = useState([]);

    // Filter states
    const [searchTerm, setSearchTerm] = useState("");
    const [roleFilter, setRoleFilter] = useState("All Roles");
    const [statusFilter, setStatusFilter] = useState("All Status");

    const [operatorsList, setOperatorsList] = useState([]);
    const [operatorFilter, setOperatorFilter] = useState(user?.userType === 'operator' ? user.operatorId : "system");
    const [subscription, setSubscription] = useState(null);

    const fetchData = async () => {
        try {
            const opId = user?.userType === 'operator' ? user.operatorId : operatorFilter;
            const [uRes, rRes, dRes] = await Promise.all([
                fetch(`/api/users/${opId}`),
                fetch(`/api/roles/${opId}`),
                fetch(`/api/departments/${opId}`)
            ]);

            const uData = uRes.ok ? await uRes.json() : [];
            const rData = rRes.ok ? await rRes.json() : [];
            const dData = dRes.ok ? await dRes.json() : [];

            setUsersList(Array.isArray(uData) ? uData : []);
            setRolesList(Array.isArray(rData) ? rData : []);
            setDeptsList(Array.isArray(dData) ? dData : []);

            if (user?.userType !== 'operator') {
                const oRes = await fetch("/api/operators");
                setOperatorsList(await oRes.json());
            }

            // Fetch subscription for limit checking (operator only)
            const subOpId = user?.userType === 'operator' ? user.operatorId : operatorFilter;
            if (subOpId && subOpId !== 'system') {
                try {
                    const sRes = await fetch(`/api/subscriptions/operator/${subOpId}`);
                    const sData = sRes.ok ? await sRes.json() : [];
                    if (Array.isArray(sData)) {
                        const active = sData.find(s => s.status === 'Active');
                        setSubscription(active || null);
                    }
                } catch (_) {}
            }
        } catch (err) {
            console.error("Fetch error:", err);
        }
    };

    useEffect(() => {
        fetchData();
    }, [operatorFilter]);

    const handleExport = () => {
        const wb = XLSX.utils.book_new();
        const exportData = usersList.map(u => ({
            'First Name': u.firstName || '',
            'Last Name': u.lastName || '',
            'Email': u.email || '',
            'Phone': u.phone || '',
            'Role': u.role || '',
            'Department': u.department || '',
            'Status': u.isActive ? 'Active' : 'Inactive',
        }));
        const ws = XLSX.utils.json_to_sheet(exportData);
        XLSX.utils.book_append_sheet(wb, ws, 'Users');
        XLSX.writeFile(wb, 'Users_List.xlsx');
    };



    const tabs = user?.userType === 'operator' ? [
        { id: "users", label: "Users", icon: icons.users }
    ] : [
        { id: "users", label: "Users", icon: icons.users },
        { id: "roles", label: "Roles", icon: icons.roles },
        { id: "departments", label: "Departments", icon: icons.departments },
    ];

    const handleEdit = (type, item) => {
        if (type === 'user') {
            setEditingUser(item);
            setShowCreateUser(true);
        } else if (type === 'role') {
            setEditingRole(item);
            setShowCreateRole(true);
        } else if (type === 'department') {
            setEditingDept(item);
            setShowCreateDept(true);
        }
    };

    const handleDelete = async (type, id) => {
        if (!window.confirm(`Are you sure you want to delete this ${type}?`)) return;
        try {
            const res = await fetch(`/api/${type}s/${id}`, {
                method: 'DELETE',
                headers: {
                    'adminName': `${user?.firstName} ${user?.lastName}`,
                    'adminEmail': user?.email
                }
            });
            if (res.ok) fetchData();
        } catch (err) {
            console.error("Delete error:", err);
        }
    };

    const CreateUserPage = ({ editingItem }) => {
        const [formData, setFormData] = useState(editingItem || {
            firstName: '', lastName: '', email: '', phone: '', employeeId: '', password: '',
            role: '', department: '', permissions: [], isActive: true,
            operatorId: user?.userType === 'operator' ? user.operatorId : ''
        });

        const basePermissions = [
            "View Dashboard", 
            "View Operators", "Create Operator", "Edit Operator", "Delete Operator",
            "View Subscriptions", "Create Subscription", "Edit Subscription", "Delete Subscription",
            "View Price Plans", "Create Price Plan", "Edit Price Plan", "Delete Price Plan",
            "View Countries", "Create Country", "Edit Country", "Delete Country",
            "View Tickets", "Create Ticket", "Edit Ticket", "Delete Ticket",
            "Manage Settings", 
            "View Email Templates", "Create Email Template", "Edit Email Template", "Delete Email Template",
            "View Users", "Create User", "Edit User", "Delete User",
            "View Roles", "Create Role", "Edit Role", "Delete Role",
            "View Departments", "Create Department", "Edit Department", "Delete Department",
            
            "View Finance", "Manage Invoices", "Manage Quotations", "Manage Expenses", "Manage Bank Accounts", "Manage Petty Cash",
            "View Trip Operations", "Manage Routes", "Manage Route Stops", "Manage Trips", "Manage Availability", "Manage Passenger Allocation", "View Trip Reports", "Manage Adhoc Trips", "Manage Shuttle Booking",
            "View Fleet", "Manage Vehicles", "View Cost Analysis", "Manage Driver Vehicle Mapping",
            "View Maintenance", "Manage Fuel", "Manage Workshops", "Manage Jobs", "Manage Service Types", "Manage Tyres", "Manage Compliance", "View Maintenance Reports",
            "View Drivers", "Manage Drivers", "Manage Attendance", "Manage Salary Logs",
            "View Vendors", "Manage Vendors", "Manage Vendor Drivers", "Manage Vendor Fleet", "Manage Vendor Documents", "Manage Vendor Contracts", "Manage Vendor Pricing",
            "View Clients", "Manage Clients"
        ];

        const operatorPermissionsList = [
            "View Dashboard", "Manage Settings",
            "View Users", "Create User", "Edit User", "Delete User",
            "View Finance", "Manage Invoices", "Manage Quotations", "Manage Expenses", "Manage Bank Accounts", "Manage Petty Cash",
            "View Trip Operations", "Manage Routes", "Manage Route Stops", "Manage Trips", "Manage Availability", "Manage Passenger Allocation", "View Trip Reports", "Manage Adhoc Trips", "Manage Shuttle Booking",
            "View Fleet", "Manage Vehicles", "View Cost Analysis", "Manage Driver Vehicle Mapping",
            "View Maintenance", "Manage Fuel", "Manage Workshops", "Manage Jobs", "Manage Service Types", "Manage Tyres", "Manage Compliance", "View Maintenance Reports",
            "View Drivers", "Manage Drivers", "Manage Attendance", "Manage Salary Logs",
            "View Vendors", "Manage Vendors", "Manage Vendor Drivers", "Manage Vendor Fleet", "Manage Vendor Documents", "Manage Vendor Contracts", "Manage Vendor Pricing",
            "View Clients", "Manage Clients"
        ];

        const adminPermissionsList = [
            "View Dashboard", 
            "View Operators", "Create Operator", "Edit Operator", "Delete Operator",
            "View Subscriptions", "Create Subscription", "Edit Subscription", "Delete Subscription",
            "View Price Plans", "Create Price Plan", "Edit Price Plan", "Delete Price Plan",
            "View Countries", "Create Country", "Edit Country", "Delete Country",
            "View Tickets", "Create Ticket", "Edit Ticket", "Delete Ticket",
            "Manage Settings", 
            "View Email Templates", "Create Email Template", "Edit Email Template", "Delete Email Template",
            "View Users", "Create User", "Edit User", "Delete User",
            "View Roles", "Create Role", "Edit Role", "Delete Role",
            "View Departments", "Create Department", "Edit Department", "Delete Department"
        ];

        const permissionsList = user?.userType === 'operator' ? operatorPermissionsList : adminPermissionsList;

        const handleSave = async () => {
            try {
                if (user?.userType !== 'operator' && (!formData.employeeId || !formData.employeeId.trim())) {
                    alert("Employee ID is mandatory.");
                    return;
                }
                const payload = { ...formData };
                if (!payload.operatorId) delete payload.operatorId;

                const url = editingItem ? `/api/users/${editingItem._id}` : "/api/users";
                const method = editingItem ? 'PUT' : 'POST';

                const res = await fetch(url, {
                    method: method,
                    headers: {
                        'Content-Type': 'application/json',
                        'adminName': `${user?.firstName} ${user?.lastName}`,
                        'adminEmail': user?.email
                    },
                    body: JSON.stringify(payload)
                });
                if (res.ok) {
                    setShowCreateUser(false);
                    setEditingUser(null);
                    fetchData();
                } else {
                    const errData = await res.json().catch(() => ({}));
                    alert(errData.message || "Failed to save user.");
                }
            } catch (err) {
                console.error("Save user error:", err);
            }
        };

        const selectedRole = rolesList?.find(r => r.name === formData.role);
        const rolePerms = selectedRole?.permissions || [];
        const isPermChecked = (p) => formData.permissions.includes(p) || rolePerms.includes(p);
        const isPermDisabled = (p) => rolePerms.includes(p);

        const togglePermission = (perm) => {
            if (isPermDisabled(perm)) return;
            setFormData(prev => ({
                ...prev,
                permissions: prev.permissions.includes(perm)
                    ? prev.permissions.filter(p => p !== perm)
                    : [...prev.permissions, perm]
            }));
        };

        const permissionGroups = user?.userType === 'operator' ? [
            { label: 'General', icon: icons.general, perms: ['View Dashboard', 'Manage Settings'] },
            { label: 'Users', icon: icons.users, perms: ['View Users', 'Create User', 'Edit User', 'Delete User'] },
            { label: 'Finance', icon: icons.finance, perms: ['View Finance', 'Manage Invoices', 'Manage Quotations', 'Manage Expenses', 'Manage Bank Accounts', 'Manage Petty Cash'] },
            { label: 'Trip Operations', icon: icons.tripOps, perms: ['View Trip Operations', 'Manage Routes', 'Manage Route Stops', 'Manage Trips', 'Manage Availability', 'Manage Passenger Allocation', 'View Trip Reports', 'Manage Adhoc Trips', 'Manage Shuttle Booking'] },
            { label: 'Fleet', icon: icons.fleet, perms: ['View Fleet', 'Manage Vehicles', 'View Cost Analysis', 'Manage Driver Vehicle Mapping'] },
            { label: 'Maintenance', icon: icons.maintenance, perms: ['View Maintenance', 'Manage Fuel', 'Manage Workshops', 'Manage Jobs', 'Manage Service Types', 'Manage Tyres', 'Manage Compliance', 'View Maintenance Reports'] },
            { label: 'Drivers', icon: icons.drivers, perms: ['View Drivers', 'Manage Drivers', 'Manage Attendance', 'Manage Salary Logs'] },
            { label: 'Vendors', icon: icons.vendors, perms: ['View Vendors', 'Manage Vendors', 'Manage Vendor Drivers', 'Manage Vendor Fleet', 'Manage Vendor Documents', 'Manage Vendor Contracts', 'Manage Vendor Pricing'] },
            { label: 'Clients', icon: icons.clients, perms: ['View Clients', 'Manage Clients'] },
        ] : [
            { label: 'General', icon: icons.general, perms: ['View Dashboard', 'Manage Settings'] },
            { label: 'Operators', icon: icons.clients, perms: ['View Operators', 'Create Operator', 'Edit Operator', 'Delete Operator'] },
            { label: 'Subscriptions', icon: icons.subscriptions, perms: ['View Subscriptions', 'Create Subscription', 'Edit Subscription', 'Delete Subscription'] },
            { label: 'Price Plans', icon: icons.finance, perms: ['View Price Plans', 'Create Price Plan', 'Edit Price Plan', 'Delete Price Plan'] },
            { label: 'Countries', icon: icons.countries, perms: ['View Countries', 'Create Country', 'Edit Country', 'Delete Country'] },
            { label: 'Tickets', icon: icons.tickets, perms: ['View Tickets', 'Create Ticket', 'Edit Ticket', 'Delete Ticket'] },
            { label: 'Email Templates', icon: icons.emailTemplates, perms: ['View Email Templates', 'Create Email Template', 'Edit Email Template', 'Delete Email Template'] },
            { label: 'Users', icon: icons.users, perms: ['View Users', 'Create User', 'Edit User', 'Delete User'] },
            { label: 'Roles', icon: icons.roles, perms: ['View Roles', 'Create Role', 'Edit Role', 'Delete Role'] },
            { label: 'Departments', icon: icons.departments, perms: ['View Departments', 'Create Department', 'Edit Department', 'Delete Department'] },
        ];

        const allPerms = permissionGroups.flatMap(g => g.perms);

        return (
            <div style={{ fontFamily: "'Inter', sans-serif", background: '#f8fafc', minHeight: '100vh' }}>
                {/* Sticky Header */}
                <div style={{ position: 'sticky', top: 0, zIndex: 10, background: '#fff', borderBottom: '1px solid #e2e8f0', padding: '14px 32px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        <button onClick={() => { setShowCreateUser(false); setEditingUser(null); }} style={{ display: 'flex', alignItems: 'center', gap: 6, background: 'none', border: 'none', color: '#64748b', fontSize: 14, fontWeight: 600, cursor: 'pointer', padding: '6px 12px', borderRadius: 8, transition: 'background 0.15s' }}
                            onMouseOver={e => e.currentTarget.style.background = '#f1f5f9'} onMouseOut={e => e.currentTarget.style.background = 'none'}>
                            ← Back to Users
                        </button>
                        <span style={{ color: '#cbd5e1' }}>|</span>
                        <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: '#1e293b' }}>{editingItem ? 'Edit User' : 'Create New User'}</h2>
                    </div>
                    <div style={{ display: 'flex', gap: 10 }}>
                        <button onClick={() => { setShowCreateUser(false); setEditingUser(null); }} style={{ padding: '9px 20px', borderRadius: 9, border: '1.5px solid #e2e8f0', background: '#fff', color: '#64748b', fontWeight: 600, fontSize: 13, cursor: 'pointer' }}>
                            Cancel
                        </button>
                        <button onClick={handleSave} style={{ padding: '9px 24px', borderRadius: 9, border: 'none', background: 'linear-gradient(135deg,#16539C,#00B2A9)', color: '#fff', fontWeight: 700, fontSize: 13, cursor: 'pointer', boxShadow: '0 4px 12px rgba(79,70,229,0.3)' }}>
                            {editingItem ? 'Update User' : 'Invite User'}
                        </button>
                    </div>
                </div>

                {/* Page Body */}
                <div style={{ maxWidth: 1100, margin: '0 auto', padding: '32px 24px', display: 'grid', gridTemplateColumns: '360px 1fr', gap: 28, alignItems: 'start' }}>

                    {/* Left Column — Basic Info */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                        <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #e2e8f0', padding: 24, boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
                            <h3 style={{ margin: '0 0 18px', fontSize: 14, fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Basic Info</h3>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
                                <div className="form-group">
                                    <label className="form-label">First Name *</label>
                                    <input type="text" className="form-input" placeholder="First name" value={formData.firstName} onChange={e => setFormData({ ...formData, firstName: e.target.value })} />
                                </div>
                                <div className="form-group">
                                    <label className="form-label">Last Name *</label>
                                    <input type="text" className="form-input" placeholder="Last name" value={formData.lastName} onChange={e => setFormData({ ...formData, lastName: e.target.value })} />
                                </div>
                            </div>
                            <div className="form-group" style={{ marginTop: 14 }}>
                                <label className="form-label">Email Address *</label>
                                <input type="email" className="form-input" placeholder="Email" value={formData.email} onChange={e => setFormData({ ...formData, email: e.target.value })} />
                            </div>
                            <div className="form-group" style={{ marginTop: 14 }}>
                                <label className="form-label">Phone Number</label>
                                <input type="text" className="form-input" placeholder="Phone" value={formData.phone} onChange={e => setFormData({ ...formData, phone: e.target.value })} />
                            </div>
                            <div className="form-group" style={{ marginTop: 14 }}>
                                <label className="form-label">Employee ID {user?.userType !== 'operator' && '*'}</label>
                                <input type="text" className="form-input" placeholder="Employee ID" value={formData.employeeId || ''} onChange={e => setFormData({ ...formData, employeeId: e.target.value })} />
                            </div>
                            <div className="form-group" style={{ marginTop: 14 }}>
                                <label className="form-label">Password {!editingItem && '*'}</label>
                                <PasswordInput className="form-input" placeholder={editingItem ? 'Leave blank to keep current' : 'Temporary password'} value={formData.password} onChange={e => setFormData({ ...formData, password: e.target.value })} />
                            </div>
                            <div className="toggle-group" style={{ marginTop: 16 }}>
                                <label className="toggle-switch">
                                    <input type="checkbox" checked={formData.isActive} onChange={e => setFormData({ ...formData, isActive: e.target.checked })} />
                                    <span className="toggle-slider"></span>
                                </label>
                                <span className="toggle-label">Account Active</span>
                                <span className="active-pill">{formData.isActive ? 'Active' : 'Inactive'}</span>
                            </div>
                        </div>

                        <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #e2e8f0', padding: 24, boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
                            <h3 style={{ margin: '0 0 18px', fontSize: 14, fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Role & Department</h3>
                            <div className="form-group">
                                <label className="form-label">User Role</label>
                                <select className="form-select" value={formData.role} onChange={e => setFormData({ ...formData, role: e.target.value })}>
                                    <option value="">Select Role</option>
                                    {Array.isArray(rolesList) && rolesList.map(r => <option key={r._id} value={r.name}>{r.name}</option>)}
                                </select>
                            </div>
                            <div className="form-group" style={{ marginTop: 14 }}>
                                <label className="form-label">Department</label>
                                <select className="form-select" value={formData.department} onChange={e => setFormData({ ...formData, department: e.target.value })}>
                                    <option value="">Assign Department</option>
                                    {Array.isArray(deptsList) && deptsList.map(d => <option key={d._id} value={d.name}>{d.name}</option>)}
                                </select>
                            </div>
                            <div className="form-group" style={{ marginTop: 14 }}>
                                <label className="form-label">Start Date</label>
                                <input type="date" className="form-input" value={formData.startDate?.split('T')[0] || ''} onChange={e => setFormData({ ...formData, startDate: e.target.value })} />
                            </div>
                        </div>
                    </div>

                    {/* Right Column — Permissions */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                        <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #e2e8f0', padding: '16px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
                            <div>
                                <h3 style={{ margin: 0, fontSize: 14, fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Permissions</h3>
                                <p style={{ margin: '4px 0 0', fontSize: 12, color: '#94a3b8' }}>{formData.permissions.length} of {allPerms.length} selected</p>
                            </div>
                            <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600, color: '#16539C' }}>
                                <input
                                    type="checkbox"
                                    checked={allPerms.every(p => isPermChecked(p))}
                                    onChange={e => {
                                        if (e.target.checked) {
                                            setFormData(prev => ({ ...prev, permissions: [...allPerms] }));
                                        } else {
                                            setFormData(prev => ({ ...prev, permissions: prev.permissions.filter(p => rolePerms.includes(p)) }));
                                        }
                                    }}
                                />
                                Select All
                            </label>
                        </div>

                        {permissionGroups.map((group, gi) => (
                            <div key={gi} style={{ background: '#fff', borderRadius: 14, border: '1px solid #e2e8f0', padding: 20, boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
                                    <h4 style={{ margin: 0, fontSize: 13, fontWeight: 700, color: '#334155', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                        {group.icon && <Icon d={group.icon} size={16} />}
                                        {group.label}
                                    </h4>
                                    <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 12, fontWeight: 600, color: '#64748b' }}>
                                        <input
                                            type="checkbox"
                                            checked={group.perms.every(p => isPermChecked(p))}
                                            disabled={group.perms.every(p => isPermDisabled(p))}
                                            onChange={e => {
                                                if (e.target.checked) {
                                                    setFormData(prev => ({ ...prev, permissions: [...new Set([...prev.permissions, ...group.perms])] }));
                                                } else {
                                                    setFormData(prev => ({ ...prev, permissions: prev.permissions.filter(p => !group.perms.includes(p) || rolePerms.includes(p)) }));
                                                }
                                            }}
                                        />
                                        All
                                    </label>
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: '8px 16px' }}>
                                    {group.perms.map((perm, pi) => (
                                        <label key={pi} style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: isPermDisabled(perm) ? 'not-allowed' : 'pointer', fontSize: 13, color: '#475569', padding: '6px 10px', borderRadius: 8, background: isPermChecked(perm) ? '#eef2ff' : '#f8fafc', border: `1px solid ${isPermChecked(perm) ? '#c3dcf5' : '#e2e8f0'}`, transition: 'all 0.15s', fontWeight: isPermChecked(perm) ? 600 : 400, opacity: isPermDisabled(perm) ? 0.6 : 1 }}>
                                            <input
                                                type="checkbox"
                                                checked={isPermChecked(perm)}
                                                disabled={isPermDisabled(perm)}
                                                onChange={() => togglePermission(perm)}
                                                style={{ accentColor: '#16539C' }}
                                            />
                                            {perm}
                                        </label>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    };


    const CreateDepartmentModal = ({ editingItem }) => {
        const [formData, setFormData] = useState(editingItem || {
            name: '',
            description: '',
            manager: '',
            isActive: true,
            operatorId: user?.userType === 'operator' ? user.operatorId : ''
        });

        const handleSave = async () => {
            try {
                const payload = { ...formData };
                if (!payload.operatorId) delete payload.operatorId;

                const url = editingItem ? `/api/departments/${editingItem._id}` : "/api/departments";
                const method = editingItem ? 'PUT' : 'POST';

                const res = await fetch(url, {
                    method: method,
                    headers: {
                        'Content-Type': 'application/json',
                        'adminName': `${user?.firstName} ${user?.lastName}`,
                        'adminEmail': user?.email
                    },
                    body: JSON.stringify(payload)
                });
                if (res.ok) {
                    setShowCreateDept(false);
                    setEditingDept(null);
                    fetchData();
                } else {
                    const errData = await res.json().catch(() => ({}));
                    alert(errData.message || "Failed to save department.");
                }
            } catch (err) {
                console.error("Save dept error:", err);
            }
        };

        return (
            <div className="modal-overlay">
                <div className="modal-content">
                    <div className="modal-header">
                        <h2>{editingItem ? 'Edit Department' : 'New Department'}</h2>
                        <button className="close-btn" onClick={() => { setShowCreateDept(false); setEditingDept(null); }}>
                            <Icon d={['M18 6L6 18', 'M6 6l12 12']} size={20} />
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="form-group">
                            <label className="form-label">Department Name *</label>
                            <input type="text" className="form-input" placeholder="Enter department name" value={formData.name} onChange={e => setFormData({ ...formData, name: e.target.value })} />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Description</label>
                            <textarea className="form-textarea" placeholder="Enter description" value={formData.description} onChange={e => setFormData({ ...formData, description: e.target.value })}></textarea>
                        </div>
                        <div className="form-group">
                            <label className="form-label">Manager</label>
                            <input type="text" className="form-input" placeholder="Type manager name" value={formData.manager} onChange={e => setFormData({ ...formData, manager: e.target.value })} />
                        </div>
                        <div className="toggle-group">
                            <label className="toggle-switch">
                                <input type="checkbox" checked={formData.isActive} onChange={e => setFormData({ ...formData, isActive: e.target.checked })} />
                                <span className="toggle-slider"></span>
                            </label>
                            <span className="toggle-label">Active Status</span>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button className="btn-cancel" onClick={() => { setShowCreateDept(false); setEditingDept(null); }}>Cancel</button>
                        <button className="btn-save" onClick={handleSave}>{editingItem ? 'Update Department' : 'Save Department'}</button>
                    </div>
                </div>
            </div>
        );
    };

    const CreateRoleModal = ({ editingItem }) => {
        const [formData, setFormData] = useState(editingItem || {
            name: '',
            description: '',
            permissions: [],
            isActive: true,
            operatorId: user?.userType === 'operator' ? user.operatorId : ''
        });
        const basePermissions = [
            "View Dashboard", 
            "View Operators", "Create Operator", "Edit Operator", "Delete Operator",
            "View Subscriptions", "Create Subscription", "Edit Subscription", "Delete Subscription",
            "View Price Plans", "Create Price Plan", "Edit Price Plan", "Delete Price Plan",
            "View Countries", "Create Country", "Edit Country", "Delete Country",
            "View Tickets", "Create Ticket", "Edit Ticket", "Delete Ticket",
            "Manage Settings", 
            "View Email Templates", "Create Email Template", "Edit Email Template", "Delete Email Template",
            "View Users", "Create User", "Edit User", "Delete User",
            "View Roles", "Create Role", "Edit Role", "Delete Role",
            "View Departments", "Create Department", "Edit Department", "Delete Department",
            
            "View Finance", "Manage Invoices", "Manage Quotations", "Manage Expenses", "Manage Bank Accounts", "Manage Petty Cash",
            "View Trip Operations", "Manage Routes", "Manage Route Stops", "Manage Trips", "Manage Availability", "Manage Passenger Allocation", "View Trip Reports", "Manage Adhoc Trips", "Manage Shuttle Booking",
            "View Fleet", "Manage Vehicles", "View Cost Analysis", "Manage Driver Vehicle Mapping",
            "View Maintenance", "Manage Fuel", "Manage Workshops", "Manage Jobs", "Manage Service Types", "Manage Tyres", "Manage Compliance", "View Maintenance Reports",
            "View Drivers", "Manage Drivers", "Manage Attendance", "Manage Salary Logs",
            "View Vendors", "Manage Vendors", "Manage Vendor Drivers", "Manage Vendor Fleet", "Manage Vendor Documents", "Manage Vendor Contracts", "Manage Vendor Pricing",
            "View Clients", "Manage Clients"
        ];

        const operatorPermissionsList = [
            "View Dashboard", "Manage Settings",
            "View Users", "Create User", "Edit User", "Delete User",
            "View Finance", "Manage Invoices", "Manage Quotations", "Manage Expenses", "Manage Bank Accounts", "Manage Petty Cash",
            "View Trip Operations", "Manage Routes", "Manage Route Stops", "Manage Trips", "Manage Availability", "Manage Passenger Allocation", "View Trip Reports", "Manage Adhoc Trips", "Manage Shuttle Booking",
            "View Fleet", "Manage Vehicles", "View Cost Analysis", "Manage Driver Vehicle Mapping",
            "View Maintenance", "Manage Fuel", "Manage Workshops", "Manage Jobs", "Manage Service Types", "Manage Tyres", "Manage Compliance", "View Maintenance Reports",
            "View Drivers", "Manage Drivers", "Manage Attendance", "Manage Salary Logs",
            "View Vendors", "Manage Vendors", "Manage Vendor Drivers", "Manage Vendor Fleet", "Manage Vendor Documents", "Manage Vendor Contracts", "Manage Vendor Pricing",
            "View Clients", "Manage Clients"
        ];

        const adminPermissionsList = [
            "View Dashboard", 
            "View Operators", "Create Operator", "Edit Operator", "Delete Operator",
            "View Subscriptions", "Create Subscription", "Edit Subscription", "Delete Subscription",
            "View Price Plans", "Create Price Plan", "Edit Price Plan", "Delete Price Plan",
            "View Countries", "Create Country", "Edit Country", "Delete Country",
            "View Tickets", "Create Ticket", "Edit Ticket", "Delete Ticket",
            "Manage Settings", 
            "View Email Templates", "Create Email Template", "Edit Email Template", "Delete Email Template",
            "View Users", "Create User", "Edit User", "Delete User",
            "View Roles", "Create Role", "Edit Role", "Delete Role",
            "View Departments", "Create Department", "Edit Department", "Delete Department"
        ];

        const permissionsList = user?.userType === 'operator' ? operatorPermissionsList : adminPermissionsList;

        const handleSave = async () => {
            try {
                const payload = { ...formData };
                if (!payload.operatorId) delete payload.operatorId;

                const url = editingItem ? `/api/roles/${editingItem._id}` : "/api/roles";
                const method = editingItem ? 'PUT' : 'POST';

                const res = await fetch(url, {
                    method: method,
                    headers: {
                        'Content-Type': 'application/json',
                        'adminName': `${user?.firstName} ${user?.lastName}`,
                        'adminEmail': user?.email
                    },
                    body: JSON.stringify(payload)
                });
                if (res.ok) {
                    setShowCreateRole(false);
                    setEditingRole(null);
                    fetchData();
                } else {
                    const errData = await res.json().catch(() => ({}));
                    alert(errData.message || "Failed to save role.");
                }
            } catch (err) {
                console.error("Save role error:", err);
            }
        };

        const togglePermission = (perm) => {
            setFormData(prev => ({
                ...prev,
                permissions: prev.permissions.includes(perm)
                    ? prev.permissions.filter(p => p !== perm)
                    : [...prev.permissions, perm]
            }));
        };

        return (
            <div className="modal-overlay">
                <div className="modal-content">
                    <div className="modal-header">
                        <h2>{editingItem ? 'Edit Role' : 'New Role'}</h2>
                        <button className="close-btn" onClick={() => { setShowCreateRole(false); setEditingRole(null); }}>
                            <Icon d={['M18 6L6 18', 'M6 6l12 12']} size={20} />
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="form-group">
                            <label className="form-label">Role Name *</label>
                            <input type="text" className="form-input" placeholder="Enter role name" value={formData.name} onChange={e => setFormData({ ...formData, name: e.target.value })} />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Description</label>
                            <textarea className="form-textarea" placeholder="Enter description" value={formData.description} onChange={e => setFormData({ ...formData, description: e.target.value })}></textarea>
                        </div>
                        <div className="form-group">
                            <label className="form-label">Permissions</label>
                            <div className="permissions-container">
                                <label className="permission-item" style={{ borderBottom: '1px solid #e2e8f0', paddingBottom: '8px', marginBottom: '4px', fontWeight: 600, color: '#16539C' }}>
                                    <input
                                        type="checkbox"
                                        checked={formData.permissions.length === permissionsList.length}
                                        onChange={(e) => setFormData(prev => ({ ...prev, permissions: e.target.checked ? [...permissionsList] : [] }))}
                                    />
                                    Select All Permissions
                                </label>
                                <div className="permissions-grid">
                                    {permissionsList.map((perm, i) => (
                                        <label key={i} className="permission-item">
                                            <input type="checkbox" checked={formData.permissions.includes(perm)} onChange={() => togglePermission(perm)} />
                                            {perm}
                                        </label>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="toggle-group">
                            <label className="toggle-switch">
                                <input type="checkbox" checked={formData.isActive} onChange={e => setFormData({ ...formData, isActive: e.target.checked })} />
                                <span className="toggle-slider"></span>
                            </label>
                            <span className="toggle-label">Active Status</span>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button className="btn-cancel" onClick={() => { setShowCreateRole(false); setEditingRole(null); }}>Cancel</button>
                        <button className="btn-save" onClick={handleSave}>{editingItem ? 'Update Role' : 'Save Role'}</button>
                    </div>
                </div>
            </div>
        );
    };

    const renderFilters = () => {
        if (activeTab === "users") {
            return (
                <div className="filters-bar">
                    <div className="search-input-wrap">
                        <Icon d={icons.search} size={16} className="search-icon-inline" />
                        <input
                            type="text"
                            placeholder="Search users..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                    <div className="filter-selects">
                        <select
                            className="filter-select"
                            value={roleFilter}
                            onChange={(e) => setRoleFilter(e.target.value)}
                        >
                            <option>All Roles</option>
                            {Array.isArray(rolesList) && rolesList.map(role => (
                                <option key={role._id} value={role.name}>{role.name}</option>
                            ))}
                        </select>
                        <select
                            className="filter-select"
                            value={statusFilter}
                            onChange={(e) => setStatusFilter(e.target.value)}
                        >
                            <option>All Status</option>
                            <option value="Active">Active</option>
                            <option value="Inactive">Inactive</option>
                        </select>
                    </div>
                    <div className="action-btns" style={{ display: 'flex', gap: '10px' }}>
                        {(() => {
                            const limit = subscription?.planId?.usersLimit;
                            const isUnlimited = !limit || limit === -1 || limit === '-1' || limit === 'Unlimited';
                            const atLimit = user?.userType === 'operator' && !isUnlimited && usersList.length >= Number(limit);
                            return atLimit ? (
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '9px 14px', borderRadius: 10, background: '#fef2f2', border: '1.5px solid #fca5a5', color: '#dc2626', fontSize: 13, fontWeight: 700 }}>
                                    ⚠️ User limit reached ({usersList.length}/{limit}) — Please upgrade your plan
                                </div>
                            ) : (
                                <>
                                    <button className="btn-primary" onClick={() => setShowImportScreen(true)} style={{ background: '#10b981', display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
                                        <Icon d={icons.export} size={16} /> Import
                                    </button>
                                    {canManage('Manage Users') && (
                                        <button className="btn-primary" onClick={() => setShowCreateUser(true)} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <Icon d={icons.plus} size={16} /> Create/Invite User
                                        </button>
                                    )}
                                </>
                            );
                        })()}
                        <button className="btn-primary" onClick={handleExport} style={{ background: '#00B2A9', display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <Icon d={icons.export} size={16} /> Export
                        </button>
                    </div>
                </div>
            );
        }

        if (activeTab === "roles") {
            return (
                <div className="filters-bar" style={{ justifyContent: 'flex-end' }}>
                    {canManage('Manage Roles') && (
                        <button className="btn-primary" onClick={() => setShowCreateRole(true)}>
                            <Icon d={icons.plus} size={16} /> Add New Role
                        </button>
                    )}
                </div>
            );
        }

        if (activeTab === "departments") {
            return (
                <div className="filters-bar" style={{ justifyContent: 'flex-end' }}>
                    {canManage('Manage Departments') && (
                        <button className="btn-primary" onClick={() => setShowCreateDept(true)}>
                            <Icon d={icons.plus} size={16} /> Add Department
                        </button>
                    )}
                </div>
            );
        }
    };

    const renderTable = () => {
        const filteredUsers = (Array.isArray(usersList) ? usersList : []).filter(u => {
            const matchesSearch = (u.firstName + " " + u.lastName + " " + u.email)
                .toLowerCase()
                .includes(searchTerm.toLowerCase());

            const matchesRole = roleFilter === "All Roles" || u.role === roleFilter;

            const statusStr = u.isActive ? "Active" : "Inactive";
            const matchesStatus = statusFilter === "All Status" || statusStr === statusFilter;

            return matchesSearch && matchesRole && matchesStatus;
        });

        switch (activeTab) {
            case "users":
                return (
                    <table className="premium-table">
                        <thead>
                            <tr>
                                <th>User Name</th>
                                <th>Employee ID</th>
                                <th>Email</th>
                                <th>Role</th>
                                <th>Department</th>
                                <th>Status</th>
                                <th>Created At</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(filteredUsers) && filteredUsers.length > 0 ? filteredUsers.map(u => (
                                <tr key={u._id}>
                                    <td>{u.firstName} {u.lastName}</td>
                                    <td>{u.employeeId || '-'}</td>
                                    <td>{u.email}</td>
                                    <td>{u.role}</td>
                                    <td>{u.department}</td>
                                    <td><span className={`status-badge ${u.isActive ? 'active' : 'inactive'}`}>{u.isActive ? 'Active' : 'Inactive'}</span></td>
                                    <td>{new Date(u.createdAt).toLocaleDateString()}</td>
                                    <td>
                                        {canManage('Manage Users') && (
                                            <>
                                                <button className="icon-btn edit" onClick={() => handleEdit('user', u)}>
                                                    <Icon d={['M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7', 'M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z']} size={16} />
                                                </button>
                                                <button className="icon-btn delete" onClick={() => handleDelete('user', u._id)}>
                                                    <Icon d={icons.trash} size={16} />
                                                </button>
                                            </>
                                        )}
                                    </td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan="8" className="empty-state">No users found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                );
            case "roles":
                return (
                    <table className="premium-table">
                        <thead>
                            <tr>
                                <th>Role Name</th>
                                <th>Description</th>
                                <th>Permissions</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(rolesList) && rolesList.length > 0 ? rolesList.map(r => (
                                <tr key={r._id}>
                                    <td>{r.name}</td>
                                    <td>{r.description}</td>
                                    <td>{r.permissions?.length || 0} Permissions</td>
                                    <td><span className={`status-badge ${r.isActive ? 'active' : 'inactive'}`}>{r.isActive ? 'Active' : 'Inactive'}</span></td>
                                    <td>
                                        {canManage('Manage Roles') && (
                                            <>
                                                <button className="icon-btn edit" onClick={() => handleEdit('role', r)}>
                                                    <Icon d={['M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7', 'M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z']} size={16} />
                                                </button>
                                                <button className="icon-btn delete" onClick={() => handleDelete('role', r._id)}>
                                                    <Icon d={icons.trash} size={16} />
                                                </button>
                                            </>
                                        )}
                                    </td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan="5" className="empty-state">No roles found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                );
            case "departments":
                return (
                    <table className="premium-table">
                        <thead>
                            <tr>
                                <th>Department Name</th>
                                <th>Description</th>
                                <th>Manager</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(deptsList) && deptsList.length > 0 ? deptsList.map(d => (
                                <tr key={d._id}>
                                    <td>{d.name}</td>
                                    <td>{d.description}</td>
                                    <td>{d.manager}</td>
                                    <td><span className={`status-badge ${d.isActive ? 'active' : 'inactive'}`}>{d.isActive ? 'Active' : 'Inactive'}</span></td>
                                    <td>
                                        {canManage('Manage Departments') && (
                                            <>
                                                <button className="icon-btn edit" onClick={() => handleEdit('department', d)}>
                                                    <Icon d={['M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7', 'M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z']} size={16} />
                                                </button>
                                                <button className="icon-btn delete" onClick={() => handleDelete('department', d._id)}>
                                                    <Icon d={icons.trash} size={16} />
                                                </button>
                                            </>
                                        )}
                                    </td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan="5" className="empty-state">No departments found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                );
            default:
                return null;
        }
    };

    if (showImportScreen) {
        return (
            <UserImportWizard
                users={usersList}
                user={user}
                onBack={() => setShowImportScreen(false)}
                onDone={() => { setShowImportScreen(false); fetchData(); }}
            />
        );
    }

    if (showCreateUser) {
        return <CreateUserPage editingItem={editingUser} />;
    }

    return (
        <div className="users-page">
            <div className="users-header">
                <h1>User Management</h1>
                <p>Manage system access, roles, and permissions.</p>
            </div>

            <div className="users-tabs">
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        className={`tab-btn ${activeTab === tab.id ? "active" : ""}`}
                        onClick={() => setActiveTab(tab.id)}
                    >
                        <Icon d={tab.icon} size={16} />
                        {tab.label}
                    </button>
                ))}
            </div>

            {renderFilters()}

            <div className="premium-table-container">
                {renderTable()}
            </div>

            {showCreateDept && <CreateDepartmentModal editingItem={editingDept} />}
            {showCreateRole && <CreateRoleModal editingItem={editingRole} />}
        </div>
    );
}

function UserImportWizard({ users, user, onBack, onDone }) {
    const [file, setFile] = useState(null);
    const [dragActive, setDragActive] = useState(false);
    const [parsedData, setParsedData] = useState([]);
    const [importing, setImporting] = useState(false);
    const [result, setResult] = useState(null);

    const existingEmails = new Set((users || []).map(u => (u.email || '').trim().toLowerCase()));

    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") setDragActive(true);
        else if (e.type === "dragleave") setDragActive(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            processFile(e.dataTransfer.files[0]);
        }
    };

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            processFile(e.target.files[0]);
        }
    };

    const processFile = (selectedFile) => {
        setFile(selectedFile);
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const bstr = e.target.result;
                const wb = XLSX.read(bstr, { type: 'binary' });
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                const data = XLSX.utils.sheet_to_json(ws);

                if (data.length === 0) {
                    alert('The Excel file is empty.');
                    setFile(null);
                    return;
                }
                
                const standardized = data.map((row) => {
                    const mapped = {};
                    Object.keys(row).forEach(key => {
                        const cleanKey = key.trim();
                        mapped[cleanKey] = row[key];
                    });
                    return mapped;
                });

                setParsedData(standardized);
            } catch (err) {
                console.error(err);
                alert("Failed to parse Excel file.");
            }
        };
        reader.readAsBinaryString(selectedFile);
    };

    const downloadTemplate = () => {
        const templateData = [{
            'First Name': 'John',
            'Last Name': 'Doe',
            'Email': 'john@example.com',
            'Phone': '+1234567890',
            'Role': 'System Admin',
            'Department': 'IT',
            'Status': 'Active'
        }];
        const worksheet = XLSX.utils.json_to_sheet(templateData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Users Template');
        XLSX.writeFile(workbook, 'Users_Import_Template.xlsx');
    };

    const handleImport = async () => {
        if (parsedData.length === 0) return;
        setImporting(true);

        try {
            const mappedUsers = parsedData.map(row => {
                return {
                    firstName: row['First Name'] || row.firstName || '',
                    lastName: row['Last Name'] || row.lastName || '',
                    email: (row['Email'] || row.email || '').trim().toLowerCase(),
                    phone: String(row['Phone'] || row.phone || ''),
                    role: row['Role'] || row.role || '',
                    department: row['Department'] || row.department || '',
                    isActive: (row['Status'] || row.status) !== 'Inactive',
                    password: 'Password123!',
                    permissions: [],
                    operatorId: user?.userType === 'operator' ? user.operatorId : ''
                };
            });

            const res = await fetch('/api/users/import', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'adminName': `${user?.firstName} ${user?.lastName}`,
                    'adminEmail': user?.email
                },
                body: JSON.stringify({
                    operatorId: user?.userType === 'operator' ? user.operatorId : '',
                    users: mappedUsers
                })
            });

            const data = await res.json();
            if (res.ok) {
                setResult({ 
                    updatedCount: data.updatedCount || 0, 
                    createdCount: data.createdCount || 0, 
                    errors: data.errors || [] 
                });
            } else {
                alert(data.message || 'Import failed');
            }
        } catch (error) {
            console.error('Import error:', error);
            alert('Failed to complete import.');
        } finally {
            setImporting(false);
        }
    };

    const matchedCount = parsedData.filter(d => {
        const e = (d['Email'] || d.email || '').trim().toLowerCase();
        return e && existingEmails.has(e);
    }).length;

    const newCount = parsedData.filter(d => {
        const e = (d['Email'] || d.email || '').trim().toLowerCase();
        return e && !existingEmails.has(e);
    }).length;

    const invalidCount = parsedData.length - matchedCount - newCount;

    const Icon = ({ d, size = 16, color = 'currentColor', strokeWidth = 2, style = {} }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" style={style}>
            {Array.isArray(d) ? d.map((path, i) => <path key={i} d={path} />) : <path d={d} />}
        </svg>
    );

    const icons = {
        upload: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4 M17 8l-5-5-5 5 M12 3v12',
        download: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4 M7 10l5 5 5-5 M12 15V3',
    };

    return (
        <div style={{ fontFamily: "'Inter', sans-serif", padding: '30px', maxWidth: '1200px', margin: '0 auto', minHeight: '100vh', background: '#f8fafc' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '30px' }}>
                <button onClick={onBack} style={{ display: 'flex', alignItems: 'center', gap: '8px', background: 'none', border: 'none', color: '#64748b', fontSize: '15px', fontWeight: '600', cursor: 'pointer' }}>
                    ← Back to Users
                </button>
                <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '700', color: '#1e293b' }}>Import Users</h2>
            </div>
            
            {result ? (
                <div style={{ background: 'white', borderRadius: '16px', padding: '40px', textAlign: 'center', boxShadow: '0 10px 25px rgba(0,0,0,0.05)', border: '1px solid #f1f5f9' }}>
                    <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '80px', height: '80px', borderRadius: '50%', background: '#d1fae5', color: '#10b981', marginBottom: '24px' }}>
                        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 6 9 17 4 12" />
                        </svg>
                    </div>
                    <h2 style={{ fontSize: '28px', fontWeight: '800', color: '#1e293b', marginBottom: '12px' }}>Import Completed!</h2>
                    <p style={{ fontSize: '15px', color: '#64748b', maxWidth: '600px', margin: '0 auto 30px' }}>
                        The users excel file has been successfully processed. Existing records were updated and new user accounts were established.
                    </p>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '20px', maxWidth: '700px', margin: '0 auto 30px' }}>
                        <div style={{ background: '#ecfdf5', border: '1px solid #a7f3d0', borderRadius: '12px', padding: '20px', textAlign: 'center' }}>
                            <div style={{ fontSize: '32px', fontWeight: '800', color: '#065f46' }}>{result.updatedCount || 0}</div>
                            <div style={{ fontSize: '13px', fontWeight: '600', color: '#047857', marginTop: '4px' }}>Users Updated</div>
                        </div>
                        <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: '12px', padding: '20px', textAlign: 'center' }}>
                            <div style={{ fontSize: '32px', fontWeight: '800', color: '#1e40af' }}>{result.createdCount || 0}</div>
                            <div style={{ fontSize: '13px', fontWeight: '600', color: '#1d4ed8', marginTop: '4px' }}>New Users Created</div>
                        </div>
                        <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: '12px', padding: '20px', textAlign: 'center' }}>
                            <div style={{ fontSize: '32px', fontWeight: '800', color: '#92400e' }}>{(result.errors?.length) || 0}</div>
                            <div style={{ fontSize: '13px', fontWeight: '600', color: '#b45309', marginTop: '4px' }}>Skipped / Warnings</div>
                        </div>
                    </div>

                    {result.errors && result.errors.length > 0 && (
                        <div style={{ maxWidth: '750px', margin: '0 auto 30px', textAlign: 'left' }}>
                            <h4 style={{ fontSize: '14px', fontWeight: '700', color: '#475569', marginBottom: '10px' }}>Details / Warnings:</h4>
                            <div style={{ maxHeight: '180px', overflowY: 'auto', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '12px', background: '#f8fafc' }}>
                                {result.errors.map((err, idx) => (
                                    <div key={idx} style={{ fontSize: '13px', color: '#64748b', padding: '6px 0', borderBottom: idx < result.errors.length - 1 ? '1px solid #e2e8f0' : 'none' }}>
                                        ⚠️ Row {err.row}: {err.message}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    <button
                        onClick={onDone}
                        style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '12px 30px', borderRadius: '10px', border: 'none', background: 'linear-gradient(135deg,#16539C,#00B2A9)', color: 'white', fontSize: '15px', fontWeight: '700', cursor: 'pointer', boxShadow: '0 4px 12px rgba(79,70,229,0.3)', transition: 'all 0.15s' }}
                    >
                        Return to Users
                    </button>
                </div>
            ) : parsedData.length === 0 ? (
                <div style={{ display: 'grid', gridTemplateColumns: '400px 1fr', gap: '30px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                        <div style={{ background: 'white', borderRadius: '16px', border: '1px solid #e2e8f0', padding: '24px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)' }}>
                            <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#1e293b', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                ℹ️ How it works
                            </h3>
                            <ul style={{ paddingLeft: '20px', margin: 0, display: 'flex', flexDirection: 'column', gap: '12px', fontSize: '13.5px', color: '#475569', lineHeight: '1.5' }}>
                                <li>The file must be an Excel sheet (<code>.xlsx</code> or <code>.xls</code>).</li>
                                <li>It matches uploaded rows to <strong>EXISTING</strong> users by their <strong>Email</strong> (case-insensitive) to update them.</li>
                                <li style={{ fontWeight: '600', color: '#16539C' }}>Unmatched emails will automatically be created as brand new user profiles!</li>
                                <li>Fields like Role, Department, Phone, and Status will be mapped.</li>
                            </ul>
                        </div>

                        <div style={{ background: 'white', borderRadius: '16px', border: '1px solid #e2e8f0', padding: '24px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)' }}>
                            <h3 style={{ fontSize: '14px', fontWeight: '700', color: '#1e293b', marginBottom: '12px' }}>Supported Fields</h3>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                {['First Name', 'Last Name', 'Email *', 'Phone', 'Role', 'Department', 'Status'].map((f, i) => (
                                    <span key={i} style={{ fontSize: '11px', fontWeight: '600', color: '#11427D', background: '#eef2ff', border: '1px solid #c3dcf5', padding: '4px 8px', borderRadius: '6px' }}>
                                        {f}
                                    </span>
                                ))}
                            </div>
                            <p style={{ fontSize: '11.5px', color: '#64748b', marginTop: '10px', margin: '10px 0 0' }}>* <strong>Email</strong> is required.</p>
                        </div>

                        <div style={{ background: '#f8fafc', borderRadius: '16px', border: '1px dashed #cbd5e1', padding: '20px', textAlign: 'center' }}>
                            <p style={{ fontSize: '13px', color: '#475569', margin: '0 0 12px' }}>Need a starting point? Download our pre-configured format template.</p>
                            <button
                                onClick={downloadTemplate}
                                style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '8px 16px', borderRadius: '8px', border: '1.5px solid #cbd5e1', background: 'white', color: '#334155', fontSize: '12.5px', fontWeight: '700', cursor: 'pointer', transition: 'all 0.15s' }}
                            >
                                <Icon d={icons.download} size={14} strokeWidth={2.5} />
                                Download Sample Template
                            </button>
                        </div>
                    </div>

                    <div
                        onDragEnter={handleDrag}
                        onDragOver={handleDrag}
                        onDragLeave={handleDrag}
                        onDrop={handleDrop}
                        style={{
                            background: dragActive ? '#f0f7ff' : 'white',
                            borderRadius: '16px',
                            border: `2px dashed ${dragActive ? '#16539C' : '#cbd5e1'}`,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '60px 40px',
                            boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)',
                            transition: 'all 0.15s',
                            cursor: 'pointer'
                        }}
                        onClick={() => document.getElementById('user-file-upload').click()}
                    >
                        <input
                            id="user-file-upload"
                            type="file"
                            accept=".xlsx,.xls"
                            onChange={handleFileChange}
                            style={{ display: 'none' }}
                        />
                        <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '64px', height: '64px', borderRadius: '16px', background: '#eef2ff', color: '#16539C', marginBottom: '20px' }}>
                            <Icon d={icons.upload} size={28} strokeWidth={2.5} />
                        </div>
                        <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#1e293b', margin: '0 0 8px' }}>Drag & Drop Excel File</h3>
                        <p style={{ fontSize: '13.5px', color: '#64748b', margin: '0 0 16px' }}>or click to browse your local files</p>
                        <span style={{ fontSize: '12px', color: '#94a3b8', background: '#f8fafc', padding: '6px 12px', borderRadius: '6px', border: '1px solid #f1f5f9' }}>
                            Supports .xlsx, .xls formats
                        </span>
                    </div>
                </div>
            ) : (
                <div style={{ background: 'white', borderRadius: '16px', border: '1px solid #e2e8f0', overflow: 'hidden', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '20px 24px', borderBottom: '1px solid #e2e8f0', background: '#f8fafc' }}>
                        <div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <span style={{ fontSize: '15px', fontWeight: '700', color: '#1e293b' }}>{file?.name}</span>
                                <span style={{ fontSize: '12px', color: '#64748b', background: '#cbd5e1', padding: '2px 8px', borderRadius: '999px', fontWeight: '600' }}>
                                    {parsedData.length} Rows Found
                                </span>
                            </div>
                            <div style={{ display: 'flex', gap: '16px', marginTop: '6px' }}>
                                <span style={{ fontSize: '12.5px', color: '#16a34a', display: 'flex', alignItems: 'center', gap: '4px', fontWeight: '600' }}>
                                    🟢 {matchedCount} will update
                                </span>
                                <span style={{ fontSize: '12.5px', color: '#1d4ed8', display: 'flex', alignItems: 'center', gap: '4px', fontWeight: '600' }}>
                                    🔵 {newCount} will create
                                </span>
                                {invalidCount > 0 && (
                                    <span style={{ fontSize: '12.5px', color: '#dc2626', display: 'flex', alignItems: 'center', gap: '4px', fontWeight: '600' }}>
                                        🔴 {invalidCount} invalid (missing Email)
                                    </span>
                                )}
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: '12px' }}>
                            <button
                                onClick={() => { setFile(null); setParsedData([]); }}
                                style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '9px 18px', borderRadius: '10px', border: '1.5px solid #cbd5e1', background: 'white', color: '#475569', fontSize: '13px', fontWeight: '700', cursor: 'pointer', transition: 'all 0.15s' }}
                            >
                                Change File
                            </button>
                            <button
                                onClick={handleImport}
                                disabled={importing || (matchedCount + newCount === 0)}
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    padding: '9px 22px',
                                    borderRadius: '10px',
                                    border: 'none',
                                    background: (matchedCount + newCount > 0) ? 'linear-gradient(135deg,#16539C,#00B2A9)' : '#cbd5e1',
                                    color: 'white',
                                    fontSize: '13px',
                                    fontWeight: '700',
                                    cursor: (matchedCount + newCount > 0) ? 'pointer' : 'not-allowed',
                                    boxShadow: (matchedCount + newCount > 0) ? '0 4px 12px rgba(79,70,229,0.3)' : 'none',
                                    transition: 'all 0.15s'
                                }}
                            >
                                {importing ? 'Processing...' : `Proceed Import (${matchedCount + newCount})`}
                            </button>
                        </div>
                    </div>

                    <div style={{ overflowX: 'auto', maxHeight: '500px' }}>
                        <table style={{ borderCollapse: 'collapse', width: '100%', minWidth: '800px' }}>
                            <thead>
                                <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                                    <th style={{ padding: '14px 20px', textAlign: 'left', fontSize: '11px', fontWeight: '700', color: '#475569', textTransform: 'uppercase' }}>Import Status</th>
                                    <th style={{ padding: '14px 20px', textAlign: 'left', fontSize: '11px', fontWeight: '700', color: '#475569', textTransform: 'uppercase' }}>First Name</th>
                                    <th style={{ padding: '14px 20px', textAlign: 'left', fontSize: '11px', fontWeight: '700', color: '#475569', textTransform: 'uppercase' }}>Last Name</th>
                                    <th style={{ padding: '14px 20px', textAlign: 'left', fontSize: '11px', fontWeight: '700', color: '#475569', textTransform: 'uppercase' }}>Email</th>
                                    <th style={{ padding: '14px 20px', textAlign: 'left', fontSize: '11px', fontWeight: '700', color: '#475569', textTransform: 'uppercase' }}>Role</th>
                                    <th style={{ padding: '14px 20px', textAlign: 'left', fontSize: '11px', fontWeight: '700', color: '#475569', textTransform: 'uppercase' }}>Department</th>
                                </tr>
                            </thead>
                            <tbody>
                                {parsedData.map((d, i) => {
                                    const email = (d['Email'] || d.email || '').trim();
                                    const isMatch = existingEmails.has(email.toLowerCase());
                                    const hasCredentials = !!email;

                                    let statusText = '';
                                    let statusStyle = {};
                                    let rowBg = '#fff';

                                    if (isMatch) {
                                        statusText = 'Updates Existing';
                                        statusStyle = { background: '#d1fae5', color: '#065f46' };
                                    } else if (hasCredentials) {
                                        statusText = 'Creates New';
                                        statusStyle = { background: '#dbeafe', color: '#1e40af' };
                                        rowBg = '#f0f7ff';
                                    } else {
                                        statusText = 'Invalid (Missing Email)';
                                        statusStyle = { background: '#fee2e2', color: '#991b1b' };
                                        rowBg = '#fef2f2';
                                    }

                                    return (
                                        <tr key={i} style={{ borderBottom: '1px solid #f1f5f9', background: rowBg }}>
                                            <td style={{ padding: '14px 20px' }}>
                                                <span style={{ fontSize: '11px', fontWeight: '700', padding: '4px 8px', borderRadius: '6px', ...statusStyle }}>
                                                    {statusText}
                                                </span>
                                            </td>
                                            <td style={{ padding: '14px 20px', fontWeight: '700', color: '#1e293b' }}>
                                                {d['First Name'] || d.firstName || '—'}
                                            </td>
                                            <td style={{ padding: '14px 20px', fontWeight: '700', color: '#1e293b' }}>
                                                {d['Last Name'] || d.lastName || '—'}
                                            </td>
                                            <td style={{ padding: '14px 20px', color: '#475569', fontSize: '13px' }}>
                                                {email || '—'}
                                            </td>
                                            <td style={{ padding: '14px 20px', color: '#475569', fontSize: '13px' }}>
                                                {d['Role'] || d.role || '—'}
                                            </td>
                                            <td style={{ padding: '14px 20px', color: '#475569', fontSize: '13px' }}>
                                                {d['Department'] || d.department || '—'}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </div>
    );
}